export enum ErrorType {
    FILE_TOO_BIG = "FILE_TOO_BIG",
    WRONG_FILE_FORMAT = "WRONG_FILE_FORMAT",
    EMPTY_MESSAGE = "EMPTY_MESSAGE",
    ATTACHMENTS_MISSING = "ATTACHMENTS_MISSING",
    ATTACHMENT_ID_MISSING = "ATTACHMENT_ID_MISSING",
    CHECKBOXES_MISSING = "CHECKBOXES_MISSING",
    NO_VALUE_SELECTED = "NO_VALUE_SELECTED",
    NO_PROVIDER_TOKEN = "NO_PROVIDER_REFRESH_TOKEN",
    NO_AUTH_TOKEN = "NO_AUTH_TOKEN",
    UNREAD_CASES_FETCH_FAILED = "UNREAD_CASES_FETCH_FAILED",
    DRAFT_ID_FETCH_FAILED = "DRAFT_ID_FETCH_FAILED",
    CASE_FETCH_FAILED = "CASE_FETCH_FAILED",
    CASE_MESSAGE_SEND_FAILED = "CASE_MESSAGE_SEND_FAILED",
    NO_INTERNET_CONNECTION = "NO_INTERNET_CONNECTION",
    UNKNOWN_ATTACHMENT_ERROR = "UNKNOWN_ATTACHMENT_ERROR",
    API_NOT_INITIALIZED = "API_NOT_INITIALIZED",
    SUPPORT_USER_NOT_FOUND = "SUPPORT_USER_NOT_FOUND",
    USER_NOT_FOUND = "USER_NOT_FOUND",
    USER_PERSONA_FETCH_FAILED = "USER_PERSONA_FETCH_FAILED",
    ASSERT_WEBFORM_AVAILABLE_FETCH_FAILED = "ASSERT_WEBFORM_AVAILABLE_FETCH_FAILED",
    SUBMIT_FORM_FAILED = "SUBMIT_FORM_FAILED",
    FORM_FETCH_FAILED = "FORM_FETCH_FAILED",
    FILE_DELETION_FAILED = "FILE_DELETION_FAILED",
    INCORRECT_CASE_STATE = "INCORRECT_CASE_STATE",
    GET_CITIES_FETCH_FAILED = "GET_CITIES_FETCH_FAILED",
    TOKEN_EXPIRED = "TOKEN_EXPIRED",
    FORM_ALREADY_SUBMITTED = "FORM_ALREADY_SUBMITTED",
    NO_RIDER_REFRESH_TOKEN = "NO_RIDER_REFRESH_TOKEN",
    NO_DRIVER_REFRESH_TOKEN = "NO_DRIVER_REFRESH_TOKEN",
    NO_COURIER_REFRESH_TOKEN = "NO_COURIER_REFRESH_TOKEN",
    NO_EATER_REFRESH_TOKEN = "NO_EATER_REFRESH_TOKEN",
    NO_PROVIDER_REFRESH_TOKEN = "NO_PROVIDER_REFRESH_TOKEN",
    ORDER_MISSING = "ORDER_MISSING",
    NO_RIDER_TOKEN = "NO_RIDER_TOKEN",
    NO_EATER_TOKEN = "NO_EATER_TOKEN",
    INTERACTION_REPLY_NOT_RECEIVED = "INTERACTION_REPLY_NOT_RECEIVED",
    INTERACTION_PENDING = "INTERACTION_PENDING",
    NO_DRIVER_MAGIC_TOKEN = "NO_DRIVER_MAGIC_TOKEN",
    ORDERS_FETCH_FAILED = "ORDERS_FETCH_FAILED",
    USER_INFO_FETCH_FAILED = "USER_INFO_FETCH_FAILED",
    CASE_MESSAGES_FETCH_FAILED = "CASE_MESSAGES_FETCH_FAILED",
    DEEPLINK_NAVIGATION_FAILED = "DEEPLINK_NAVIGATION_FAILED",
    TOO_MANY_DOMAIN_EVENTS = "TOO_MANY_DOMAIN_EVENTS",
    MISSING_BRAND = "MISSING_BRAND",
    ACTION_RATE_LIMITED = "ACTION_RATE_LIMITED",
    FLOW_STEP_NOT_FOUND = "FLOW_STEP_NOT_FOUND",
    FLOW_NOT_FOUND = "FLOW_NOT_FOUND",
    FLOW_FETCH_FAILED = "FLOW_FETCH_FAILED",
    REFRESH_TOKEN_INVALID = "REFRESH_TOKEN_INVALID",
    SESSION_STORAGE_ACCESS_DENIED = "SESSION_STORAGE_ACCESS_DENIED",
    TRANSLATIONS_LOAD_FAILED = "TRANSLATIONS_LOAD_FAILED",
    FILE_UPLOAD_FAILED = "FILE_UPLOAD_FAILED",
    FILE_UPLOAD_FAILED_SINGLE = "FILE_UPLOAD_FAILED_SINGLE",
    FILE_UPLOAD_FAILED_ONE_OF_MULTIPLE = "FILE_UPLOAD_FAILED_ONE_OF_MULTIPLE",
    FILE_UPLOAD_FAILED_SOME_OF_MULTIPLE = "FILE_UPLOAD_FAILED_SOME_OF_MULTIPLE",
    APPLY_FLOW_ACTION_FAILED = "APPLY_FLOW_ACTION_FAILED",
    UNKNOWN_ROUTE = "UNKNOWN_ROUTE",

    // Env errors
    NOT_ALLOWED_ON_CURRENT_ENV = "NOT_ALLOWED_ON_CURRENT_ENV",

    // Auth errors
    AUTH_API_INIT_FAILED = "AUTH_API_INIT_FAILED",
    AUTH_BROKER_SETUP_FAILED = "AUTH_BROKER_SETUP_FAILED",
    AUTH_MISSING_TOKEN = "AUTH_MISSING_TOKEN",
    AUTH_TOKEN_DECODE_FAILED = "AUTH_TOKEN_DECODE_FAILED",
    AUTH_TOKEN_REFRESH_FAILED = "AUTH_TOKEN_REFRESH_FAILED",

    // Config errors
    CONFIG_INVALID_APP_MODE = "CONFIG_INVALID_APP_MODE",
    CONFIG_MISSING_DEEPLINK_PREFIX = "CONFIG_MISSING_DEEPLINK_PREFIX",
    CONFIG_MISSING_CASE_ID = "CONFIG_MISSING_CASE_ID",
    CONFIG_MISSING_API_URL = "CONFIG_MISSING_API_URL",
    CONFIG_INVALID_USER_TYPE = "CONFIG_INVALID_USER_TYPE",
    CONFIG_MISSING_ENTRY_POINT = "CONFIG_MISSING_ENTRY_POINT",
    CONFIG_INVALID_BRAND = "CONFIG_INVALID_BRAND",

    // Data errors
    DATA_INVALID_STATE = "DATA_INVALID_STATE",
    DATA_PARSE_ERROR = "DATA_PARSE_ERROR",

    // UI errors
    UI_RENDER_ERROR = "UI_RENDER_ERROR",
    UI_DEBUG_TEST = "UI_DEBUG_TEST",
    UI_INVALID_CHAR_LIMIT = "UI_INVALID_CHAR_LIMIT",
    UI_INVALID_STATE = "UI_INVALID_STATE",

    // Support errors
    SUPPORT_TIMEOUT = "SUPPORT_TIMEOUT",

    // API errors
    API_MISSING_USER_ID = "API_MISSING_USER_ID",
    API_MISSING_BASE_URL = "API_MISSING_BASE_URL",
    API_UNKNOWN_ERROR = "API_UNKNOWN_ERROR",
    ENTITY_NOT_FOUND = "ENTITY_NOT_FOUND",

    // FAQ errors
    FAQ_SECTIONS_FETCH_FAILED = "FAQ_SECTIONS_FETCH_FAILED",
    FAQ_ARTICLES_FETCH_FAILED = "FAQ_ARTICLES_FETCH_FAILED",
    FAQ_ARTICLE_FETCH_FAILED = "FAQ_ARTICLE_FETCH_FAILED",
    FAQ_SUGGESTED_ARTICLES_FETCH_FAILED = "FAQ_SUGGESTED_ARTICLES_FETCH_FAILED",

    // Issue selection
    ISSUE_SELECTION_CONFIG_FETCH_FAILED = "ISSUE_SELECTION_CONFIG_FETCH_FAILED",
    NO_ONGOING_ISSUE_SELECTION = "NO_ONGOING_ISSUE_SELECTION",

    // Misc
    CHAT_LIMIT_CONFIG_ERROR = "CHAT_LIMIT_CONFIG_ERROR",
    CLIPBOARD_COPY_FAILED = "CLIPBOARD_COPY_FAILED",
    SUPPORT_USER_ACTION_NOT_ALLOWED = "SUPPORT_USER_ACTION_NOT_ALLOWED",
    MISSING_PHONE_NUMBER = "MISSING_PHONE_NUMBER",
    INVALID_LINK_TYPE = "INVALID_LINK_TYPE",
    FAILED_MESSAGES_CACHE_SAVE_ERROR = "FAILED_MESSAGES_CACHE_SAVE_ERROR",
    FAILED_MESSAGES_CACHE_LOAD_ERROR = "FAILED_MESSAGES_CACHE_LOAD_ERROR",

    // Transport layer errors
    HTTP_REQUEST_ABORT_ERROR = "HTTP_REQUEST_ABORT_ERROR",
    HTTP_REQUEST_NETWORK_ERROR = "HTTP_REQUEST_NETWORK_ERROR",
}
